/**
 * @generated SignedSource<<4c9b72e6b928bf649b7336ec2edae506>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SbSharedRelatedItems_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"SbSharedItemTrackingProvider_viewer" | "SharedItemTile_viewer">;
  readonly " $fragmentType": "SbSharedRelatedItems_viewer";
};
export type SbSharedRelatedItems_viewer$key = {
  readonly " $data"?: SbSharedRelatedItems_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"SbSharedRelatedItems_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbSharedRelatedItems_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SharedItemTile_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbSharedItemTrackingProvider_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "b28cdb717718829a259ebb7dad1fe3d0";

export default node;
